import React from 'react'
import './Footer.css'

export default function Footer() {
  return (
    <footer>
      <p>@2023 {window.location.host} All Rights Reserved</p>
      <p>
        <a href="/policy.html">Privacy Policy</a> <span>·</span> <a href="/policy.html">Terms of Service</a>
      </p>
      <p><a href="/useragreement.html">About us at：h5service@{window.location.host}</a></p>
    </footer>
  )
}
